__turbopack_context__.v({
  "bar": "-_MOCG_bar",
  "error": "-_MOCG_error",
  "indeterminate": "-_MOCG_indeterminate",
  "info": "-_MOCG_info",
  "lg": "-_MOCG_lg",
  "md": "-_MOCG_md",
  "progress-sweep": "-_MOCG_progress-sweep",
  "root": "-_MOCG_root",
  "sm": "-_MOCG_sm",
  "success": "-_MOCG_success",
  "warning": "-_MOCG_warning",
});
